import imports from '../../api/imports';
import * as types from '../mutation-types';

const state = {
  imports: null,
  selectedImport: null
};

const getters = {
  BankImports: state => state.imports,
  SelectedImport: state => state.selectedImport
};

const actions = {
  getBankImports({ commit, dispatch }) {
    imports.getImports().then(bankImports => {
      commit(types.SET_IMPORTS, bankImports);
      if (bankImports.length > 0) {
        dispatch('selectBankImportFile', bankImports[0].id);
      }
    });
  },
  selectBankImportFile({ commit }, importId) {
    imports.getFile(importId).then(importFile => commit(types.SET_IMPORT_FILE, importFile));
  }
};

const mutations = {
  [types.SET_IMPORTS](state, bankImports) {
    state.imports = bankImports;
  },
  [types.SET_IMPORT_FILE](state, importFile) {
    state.selectedImport = importFile;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
